import { MessageCircle, Users } from "lucide-react";
import { Language } from "../../../utils/dictionary";
import { INTEGRATIONS_UI_CONFIG } from "../config/integrations.config";
import type { ChannelWizardConfig } from "./ChannelIntegrationWizard";

const FLUXI_LOGO = "https://fluxi.s3.amazonaws.com/prod/assets/fluxi/fluxi-logo.svg";

export const instagramChannelConfig: ChannelWizardConfig = {
  channel: "instagram",
  title: {
    [Language.SPANISH]: "Conectar Instagram",
    [Language.ENGLISH]: "Connect Instagram",
    [Language.PORTUGUESE]: "Conectar Instagram",
  },
  description: {
    [Language.SPANISH]:
      "Conecta tu cuenta profesional de Instagram para gestionar DMs desde la misma bandeja de Fluxi.",
    [Language.ENGLISH]:
      "Connect your Instagram professional account to manage DMs from the same Fluxi inbox.",
    [Language.PORTUGUESE]:
      "Conecte sua conta profissional do Instagram para gerenciar DMs na mesma caixa do Fluxi.",
  },
  logoSrc: INTEGRATIONS_UI_CONFIG.instagram.logoSrc,
  fluxiLogoSrc: FLUXI_LOGO,
  accentColor: "#E1306C",
  connectButtonLabel: {
    [Language.SPANISH]: "Conectar con Instagram",
    [Language.ENGLISH]: "Connect with Instagram",
    [Language.PORTUGUESE]: "Conectar com Instagram",
  },
  permissions: [
    {
      id: "instagram_business_manage_messages",
      label: {
        [Language.SPANISH]: "Gestionar mensajes directos",
        [Language.ENGLISH]: "Manage direct messages",
        [Language.PORTUGUESE]: "Gerenciar mensagens diretas",
      },
    },
    {
      id: "instagram_business_basic",
      label: {
        [Language.SPANISH]: "Leer perfil e información básica",
        [Language.ENGLISH]: "Read profile and basic info",
        [Language.PORTUGUESE]: "Ler perfil e informações básicas",
      },
    },
  ],
  checklist: [
    {
      id: "professional_account",
      label: {
        [Language.SPANISH]: "Tener una cuenta profesional de Instagram",
        [Language.ENGLISH]: "Have an Instagram professional account",
        [Language.PORTUGUESE]: "Ter uma conta profissional do Instagram",
      },
    },
    {
      id: "linked_page",
      label: {
        [Language.SPANISH]: "Estar vinculada a una página de Facebook",
        [Language.ENGLISH]: "Be linked to a Facebook Page",
        [Language.PORTUGUESE]: "Estar vinculada a uma página do Facebook",
      },
    },
  ],
  connectionSteps: [
    {
      id: "login",
      label: {
        [Language.SPANISH]: "Inicia sesión en Instagram",
        [Language.ENGLISH]: "Sign in with Instagram",
        [Language.PORTUGUESE]: "Entre no Instagram",
      },
    },
    {
      id: "select_ig",
      label: {
        [Language.SPANISH]: "Selecciona la cuenta de Instagram",
        [Language.ENGLISH]: "Select the Instagram account",
        [Language.PORTUGUESE]: "Selecione a conta do Instagram",
      },
    },
    {
      id: "confirm",
      label: {
        [Language.SPANISH]: "Autoriza permisos de mensajería",
        [Language.ENGLISH]: "Authorize messaging permissions",
        [Language.PORTUGUESE]: "Autorize permissões de mensagens",
      },
    },
  ],
  features: [
    {
      icon: MessageCircle,
      label: {
        [Language.SPANISH]: "DMs de Instagram en la bandeja omnicanal",
        [Language.ENGLISH]: "Instagram DMs in the omnichannel inbox",
        [Language.PORTUGUESE]: "DMs do Instagram na caixa omnicanal",
      },
    },
    {
      icon: Users,
      label: {
        [Language.SPANISH]: "Contexto unificado del contacto",
        [Language.ENGLISH]: "Unified contact context",
        [Language.PORTUGUESE]: "Contexto unificado do contato",
      },
    },
  ],
};
